import { getParentByClass, addClass, removeClass } from "../helper/helper";

export function initToggleDropdown() {
  const toggleItems = document.querySelectorAll(".dropdown-toggle");
  const desktopBreakpoint = 1024;

  const getTopLevelTrigger = function (menuItem) {
    return menuItem.querySelector(":scope > .mb-menu-item-label[aria-haspopup='true']");
  };

  const setExpandedState = function (menuItem, expanded) {
    const toggle = menuItem.querySelector(":scope > .dropdown-toggle");
    const trigger = getTopLevelTrigger(menuItem);

    if (toggle) {
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    if (trigger) {
      trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    if (expanded) {
      addClass(menuItem, "menu-expanded");
    } else {
      removeClass(menuItem, "menu-expanded");
    }
  };

  const closeOtherTopLevelSubmenus = function (currentMenuItem) {
    const topLevelOpenItems = document.querySelectorAll(".mb-menu > .menu-item.menu-expanded.menu-item-has-children");

    topLevelOpenItems.forEach(function (openItem) {
      if (openItem === currentMenuItem) return;
      setExpandedState(openItem, false);
    });
  };

  const focusFirstSubmenuItem = function (menuItem) {
    const submenu = getDirectSubmenu(menuItem);
    if (!submenu) return false;

    const focusableSelector = "a[href], button:not([disabled]), .mb-menu-item-label[tabindex='0'], [tabindex]:not([tabindex='-1'])";
    const focusableElements = submenu.querySelectorAll(focusableSelector);

    for (let i = 0; i < focusableElements.length; i++) {
      const element = focusableElements[i];
      if (element.offsetParent === null) continue;
      element.focus();
      return true;
    }

    return false;
  };

  const getTopLevelMenuItems = function () {
    return Array.from(document.querySelectorAll(
      ".mb-menu > .menu-item-has-children > .mb-menu-item-label[aria-haspopup='true']"
    ));
  };

  const focusNextTopLevelItem = function (currentTrigger, direction) {
    const allItems = getTopLevelMenuItems();
    if (allItems.length === 0) return;

    const currentIndex = allItems.indexOf(currentTrigger);
    if (currentIndex === -1) return;

    let nextIndex;
    if (direction === "next") {
      nextIndex = (currentIndex + 1) % allItems.length;
    } else {
      nextIndex = (currentIndex - 1 + allItems.length) % allItems.length;
    }

    allItems[nextIndex].focus();
  };

  for (let i = 0; i < toggleItems.length; i++) {
    toggleItems[i].addEventListener("click", function () {
      let toggle = toggleItems[i].getAttribute("aria-expanded");
      let menuItem = getParentByClass(toggleItems[i], "menu-item");

      if (toggle == "true") {
        toggleItems[i].setAttribute("aria-expanded", "false");
        removeClass(menuItem, "menu-expanded");
      } else {
        toggleItems[i].setAttribute("aria-expanded", "true");
        addClass(menuItem, "menu-expanded");
      }
    });
  }

  const topLevelKeyboardTriggers = document.querySelectorAll(
    ".mb-menu > .menu-item-has-children > .mb-menu-item-label[aria-haspopup='true']"
  );

  topLevelKeyboardTriggers.forEach(function (trigger) {
    const menuItem = getParentByClass(trigger, "menu-item");
    if (!menuItem) return;

    trigger.addEventListener("keydown", function (event) {
      if (window.innerWidth <= desktopBreakpoint) return;

      if (event.key === "Enter") {
        event.preventDefault();

        const isExpanded = menuItem.classList.contains("menu-expanded");
        closeOtherTopLevelSubmenus(menuItem);
        setExpandedState(menuItem, !isExpanded);
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();

        closeOtherTopLevelSubmenus(menuItem);
        setExpandedState(menuItem, true);
        focusFirstSubmenuItem(menuItem);
      }

      if (event.key === "Escape") {
        event.preventDefault();
        setExpandedState(menuItem, false);
        trigger.focus();
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        focusNextTopLevelItem(trigger, "next");
      }

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        focusNextTopLevelItem(trigger, "prev");
      }
    });
  });

  document.addEventListener("keydown", function (event) {
    if (window.innerWidth <= desktopBreakpoint) return;
    if (event.key !== "Escape") return;

    const activeElement = document.activeElement;
    if (!activeElement) return;

    const activeTopLevelMenuItem = activeElement.closest(
      ".mb-menu > .menu-item-has-children.menu-expanded"
    );

    if (!activeTopLevelMenuItem) return;

    event.preventDefault();

    setExpandedState(activeTopLevelMenuItem, false);

    const trigger = getTopLevelTrigger(activeTopLevelMenuItem);
    if (trigger) {
      trigger.focus();
    }
  });

  document.addEventListener("click", function (event) {
    if (window.innerWidth <= desktopBreakpoint) return;

    if (event.target.closest(".mb-menu") || event.target.closest("#mb-nav-icon")) {
      return;
    }

    closeOtherTopLevelSubmenus(null);
  });

  window.addEventListener("resize", function () {
    if (window.innerWidth <= desktopBreakpoint) {
      closeOtherTopLevelSubmenus(null);
    }
  });
}

export function disableEmptyNavLinks() {
  document
    .querySelectorAll('.menu-item a[href="#"]')
    .forEach(function (element) {
      if (element.closest("#mb-footer-menu")) {
        element.setAttribute("tabindex", "-1");
        element.setAttribute("aria-hidden", "true");
      }

      // Skip if parent menu-item has children
      if (element.closest('.menu-item-has-children')) {
        return;
      }
      element.addEventListener("click", function (event) {
        event.preventDefault();
      });
    });
}

export function initAccessibilityToggle() {
  const accessibilityToggle = document.getElementById("mb-accessibility-toggle");
  const accessibilityPanel = document.getElementById("mb-accessibility-panel");
  const accessibilityBackButton = document.getElementById("mb-accessibility-back");
  const mainMenuContainer = document.getElementById("mb-main-menu");

  if (!accessibilityToggle || !accessibilityPanel) return;

  const closeAccessibilityPanel = function () {
    accessibilityPanel.hidden = true;
    accessibilityPanel.classList.remove("open");
    accessibilityToggle.classList.remove("open");
    accessibilityToggle.setAttribute("aria-expanded", "false");
  };

  const openAccessibilityPanel = function () {
    accessibilityPanel.hidden = false;
    accessibilityPanel.classList.add("open");
    accessibilityToggle.classList.add("open");
    accessibilityToggle.setAttribute("aria-expanded", "true");
  };

  accessibilityToggle.addEventListener("click", function (event) {
    event.preventDefault();
    const isExpanded = accessibilityToggle.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      closeAccessibilityPanel();
    } else {
      openAccessibilityPanel();
    }
  });

  if (accessibilityBackButton) {
    accessibilityBackButton.addEventListener("click", function (event) {
      event.preventDefault();
      closeAccessibilityPanel();
    });
  }

  if (mainMenuContainer) {
    const menuObserver = new MutationObserver(function () {
      if (!mainMenuContainer.classList.contains("open")) {
        closeAccessibilityPanel();
      }
    });

    menuObserver.observe(mainMenuContainer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
}

export function initMobileFirstLevelMenu() {
  const mobileBreakpoint = 1024; // lm breakpoint is 64rem = 1024px

  const mainMenu = document.querySelector(".mb-menu");
  if (!mainMenu) return;

  const firstLevelItems = mainMenu.querySelectorAll(":scope > .menu-item:not(.mb-button-menuentry)");

  firstLevelItems.forEach((item) => {
    // Only process items with children
    if (!item.classList.contains("menu-item-has-children")) return;

    const link = getMenuItemMainTrigger(item);
    if (!link) return;

    // Add arrow icon to the link
    const existingArrow = link.querySelector(".mb-menu-arrow");
    if (!existingArrow) {
      const arrow = document.createElement("span");
      arrow.className = "mb-menu-arrow";
      arrow.setAttribute("aria-hidden", "true");
      arrow.textContent = ">";
      link.appendChild(arrow);
    }

    ensureMobileBackButton(item);

  });

  // Delegate click handling to keep original desktop submenu DOM and open it inline on mobile.
  mainMenu.addEventListener("click", function (e) {
    if (window.innerWidth > mobileBreakpoint) return;

    const backButton = e.target.closest(".mb-submenu-back-button");
    if (backButton) {
      const submenu = backButton.closest(".sub-menu");
      const parentMenuItem = submenu && submenu.parentElement;

      if (parentMenuItem && parentMenuItem.classList.contains("menu-item-has-children")) {
        e.preventDefault();
        e.stopPropagation();
        closeMenuItemInline(parentMenuItem);
      }

      return;
    }

    const clickedTrigger = e.target.closest("a, .mb-menu-item-label");
    if (!clickedTrigger) return;

    const clickedMenuItem = clickedTrigger.closest(".menu-item-has-children");
    if (!clickedMenuItem || !mainMenu.contains(clickedMenuItem)) return;

    const expectedTrigger = getMenuItemMainTrigger(clickedMenuItem);
    if (!expectedTrigger || (clickedTrigger !== expectedTrigger && !expectedTrigger.contains(clickedTrigger))) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    toggleMenuItemInline(clickedMenuItem, mainMenu);
  });

  window.addEventListener("resize", function () {
    if (window.innerWidth > mobileBreakpoint) {
      resetMobileExpandedState(mainMenu);
    }
  });
}

function ensureMobileBackButton(menuItem) {
  const submenu = getDirectSubmenu(menuItem);
  if (!submenu) return;

  if (submenu.querySelector(":scope > .mb-submenu-back-item")) return;

  const trigger = getMenuItemMainTrigger(menuItem);
  const triggerLabel = trigger ? trigger.textContent.trim().replace(/[<>→]/g, "").trim() : "";

  const backItem = document.createElement("li");
  backItem.className = "mb-submenu-back-item";

  const backButton = document.createElement("button");
  backButton.type = "button";
  backButton.className = "mb-submenu-back-button";
  backButton.setAttribute("aria-label", triggerLabel ? `Zuruck zu ${triggerLabel}` : "Submenu schliessen");
  const arrowMaskId = `mask0_mb_back_${Math.random().toString(36).slice(2, 10)}`;
  const arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="${arrowMaskId}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" fill="#D9D9D9" /></mask><g mask="url(#${arrowMaskId})"><path d="M10.6538 21.3075L1 11.6538L10.6538 2L12.073 3.41925L3.83825 11.6538L12.073 19.8883L10.6538 21.3075Z" fill="#1C1B1F" /></g></svg>`;
  backButton.innerHTML = `<span class='mb-submenu-back-arrow' aria-hidden='true'>${arrowSvg}</span><span class='mb-submenu-back-text'>${triggerLabel || "Menu"}</span>`;

  backItem.appendChild(backButton);
  submenu.insertBefore(backItem, submenu.firstChild);
}

function getMenuItemMainTrigger(menuItem) {
  for (let i = 0; i < menuItem.children.length; i++) {
    const child = menuItem.children[i];
    if (child.matches && (child.matches("a") || child.matches(".mb-menu-item-label"))) {
      return child;
    }
  }

  return null;
}

function getDirectSubmenu(menuItem) {
  for (let i = 0; i < menuItem.children.length; i++) {
    const child = menuItem.children[i];
    if (child.classList && child.classList.contains("sub-menu")) {
      return child;
    }
  }

  return null;
}

function toggleMenuItemInline(menuItem, mainMenu) {
  const submenu = getDirectSubmenu(menuItem);
  if (!submenu) return;

  const toggle = menuItem.querySelector(":scope > .dropdown-toggle");
  const isExpanded = menuItem.classList.contains("menu-expanded");

  if (menuItem.parentElement === mainMenu) {
    // Keep only one top-level submenu open at a time on mobile.
    const expandedTopLevelItems = mainMenu.querySelectorAll(":scope > .menu-item.menu-expanded");
    expandedTopLevelItems.forEach((expandedItem) => {
      if (expandedItem === menuItem) return;

      closeMenuItemInline(expandedItem);
    });
  }

  menuItem.classList.toggle("menu-expanded", !isExpanded);
  if (toggle) {
    toggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");
  }
}

function closeMenuItemInline(menuItem) {
  menuItem.classList.remove("menu-expanded");

  const toggle = menuItem.querySelector(":scope > .dropdown-toggle");
  if (toggle) {
    toggle.setAttribute("aria-expanded", "false");
  }
}

function resetMobileExpandedState(mainMenu) {
  const expandedItems = mainMenu.querySelectorAll(".menu-item.menu-expanded");

  expandedItems.forEach((item) => {
    item.classList.remove("menu-expanded");
  });

  const toggles = mainMenu.querySelectorAll(".dropdown-toggle[aria-expanded='true']");
  toggles.forEach((toggle) => {
    toggle.setAttribute("aria-expanded", "false");
  });
}
